import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addAptosWalletStandardExtension } from '../walletStandard/addAptosWalletStandardExtension';

/**
 * Adds the Aptos extension to the Dynamic client.
 *
 * This is a convenience function that adds support for all of Aptos wallets that support the Aptos Wallet Standard,
 * like Petra, Backpack, OKX, Nightly, and more.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addAptosExtension = (client = getDefaultClient()): void => {
  addAptosWalletStandardExtension(client);
};
